module.exports = __webpack_public_path__ + "img/Singapore-3-hover.413cebe9.jpg";